import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: -ms-grid;
    display: grid;
    grid-template-columns: auto auto;
    margin: 25px 0 0 25px;
`;
